(() => {
  if (window.__hfUpsellLayoutInitialized) return;
  window.__hfUpsellLayoutInitialized = true;

  const SELECTOR = '.product-upsell.product-upsell--with-products';

  const __thisSrc = (document.currentScript && document.currentScript.src) || '';
  const __carouselSrc = __thisSrc ? __thisSrc.replace(/[^\/]+$/, 'hf-carousel.js') : '';

  function shuffle(arr) {
    for (let i = arr.length - 1; i > 0; i--) {
      const j = Math.floor(Math.random() * (i + 1));
      [arr[i], arr[j]] = [arr[j], arr[i]];
    }
    return arr;
  }

  function getCount(el) {
    const w = window.innerWidth;
    const cd = parseInt(el.dataset.countDesktop, 10) || 1;
    const cm = parseInt(el.dataset.countMobile, 10) || 1;
    return w < 750 ? cm : cd;
  }

  function initStacking(el) {
    const container = el.querySelector('[data-upsell-container]');
    if (!container) return;
    const cards = Array.from(container.querySelectorAll(':scope > [data-upsell-card]'));
    if (cards.length === 0) {
      el.style.display = 'none';
      return;
    }

    shuffle(cards);
    const n = Math.min(getCount(el), cards.length);
    if (n === 0) {
      el.style.display = 'none';
      return;
    }

    const visible = cards.slice(0, n);
    const hidden = cards.slice(n);
    hidden.forEach((c) => c.remove());
    visible.forEach((c) => container.appendChild(c));

    el.classList.add('product-upsell--ready');
  }

  function setupDropdownEscape(el) {
    const dropdowns = el.querySelectorAll('.upsell-dd');
    dropdowns.forEach((dd) => {
      const btn = dd.querySelector('.upsell-dd__button');
      const list = dd.querySelector('.upsell-dd__list');
      if (!btn || !list) return;

      let placeholder = null;

      const restore = () => {
        if (placeholder && placeholder.parentNode) {
          placeholder.parentNode.replaceChild(list, placeholder);
          placeholder = null;
        }
        list.style.position = '';
        list.style.top = '';
        list.style.bottom = '';
        list.style.left = '';
        list.style.right = '';
        list.style.minWidth = '';
        list.style.maxHeight = '';
        list.style.overflowY = '';
        list.style.zIndex = '';
        list.style.display = '';
        list.style.borderRadius = '';
      };

      const place = () => {
        if (dd.getAttribute('aria-expanded') !== 'true') {
          restore();
          return;
        }

        if (list.parentElement !== document.body) {
          placeholder = document.createComment('upsell-dd-placeholder');
          list.parentNode.insertBefore(placeholder, list);
          document.body.appendChild(list);
        }

        const rect = btn.getBoundingClientRect();
        list.style.display = 'block';
        list.style.position = 'fixed';
        list.style.right = 'auto';
        list.style.bottom = 'auto';
        list.style.minWidth = rect.width + 'px';
        list.style.zIndex = '10001';
        list.style.left = rect.left + 'px';
        list.style.top = rect.bottom + 6 + 'px';
        list.style.borderRadius = getComputedStyle(btn).borderRadius;

        const margin = 12;
        const cap = 240;
        const spaceBelow = window.innerHeight - rect.bottom - margin;
        list.style.maxHeight = Math.max(120, Math.min(cap, spaceBelow)) + 'px';
        list.style.overflowY = 'auto';
      };

      const obs = new MutationObserver(place);
      obs.observe(dd, { attributes: true, attributeFilter: ['aria-expanded'] });

      window.addEventListener('scroll', place, { passive: true });
      window.addEventListener('resize', place);
    });
  }

  function initCarousel(el) {
    const container = el.querySelector('[data-upsell-container]');
    if (!container) return;
    const list = container.querySelector('.hf-carousel__list');
    if (!list) return;
    const slides = Array.from(list.querySelectorAll(':scope > .hf-upsell-slide'));
    if (slides.length === 0) {
      el.style.display = 'none';
      return;
    }

    shuffle(slides);
    const n = Math.min(getCount(el), slides.length);
    if (n === 0) {
      el.style.display = 'none';
      return;
    }

    const visible = slides.slice(0, n);
    const hidden = slides.slice(n);
    hidden.forEach((s) => s.remove());
    visible.forEach((s) => list.appendChild(s));

    function loadCarousel(cb) {
      if (window.HfCarousel) return cb();
      var existing = document.querySelector('script[data-hf-carousel-loader]');
      if (existing) {
        existing.addEventListener('load', cb, { once: true });
        return;
      }
      if (!__carouselSrc) return;
      var s = document.createElement('script');
      s.src = __carouselSrc;
      s.dataset.hfCarouselLoader = 'true';
      s.async = false;
      s.onload = cb;
      document.head.appendChild(s);
    }

    loadCarousel(() => {
      const carouselEl = container.querySelector('.hf-carousel');
      const trackEl = carouselEl && carouselEl.querySelector('.hf-carousel__track');
      const listEl = carouselEl && carouselEl.querySelector('.hf-carousel__list');
      if (!trackEl || !listEl || carouselEl.dataset.hfCarouselInit === 'true') {
        setupDropdownEscape(el);
        el.classList.add('product-upsell--ready');
        return;
      }
      carouselEl.dataset.hfCarouselInit = 'true';

      const autoplay = container.dataset.autoplay === 'true';
      const autoplaySpeed = (parseInt(container.dataset.autoplaySpeed, 10) || 4) * 1000;
      const hasMultiple = visible.length > 1;

      listEl.style.gap = '32px';
      Array.from(listEl.children).forEach((s) => {
        if (s.classList && s.classList.contains('hf-carousel__slide')) {
          s.style.flex = '0 0 100%';
          s.style.width = '100%';
        }
      });

      const carousel = window.HfCarousel(trackEl, {
        loop: false,
        align: 'start',
        duration: 400,
        watchDrag: hasMultiple,
        perView: 1,
        autoplay: autoplay && hasMultiple ? {
          delay: autoplaySpeed,
          stopOnInteraction: true,
          stopOnMouseEnter: true,
        } : null,
      });

      if (!carousel) {
        setupDropdownEscape(el);
        el.classList.add('product-upsell--ready');
        return;
      }
      trackEl._hfCarousel = carousel;

      const navPrev = container.querySelector('.slider-button--prev');
      const navNext = container.querySelector('.slider-button--next');
      const progressBar = container.querySelector('.hf-slider-progress__bar');

      function updateProgress() {
        if (!progressBar) return;
        const snaps = carousel.scrollSnapList();
        const end = snaps.length || 1;
        const rate = Math.min((carousel.selectedScrollSnap() + 1) / end, 1);
        progressBar.style.width = String(100 * rate) + '%';
      }

      carousel.on('init', updateProgress);
      carousel.on('select', () => {
        updateProgress();
        el.querySelectorAll('.upsell-dd[aria-expanded="true"]').forEach((dd) => {
          dd.setAttribute('aria-expanded', 'false');
          const b = dd.querySelector('.upsell-dd__button');
          if (b) b.setAttribute('aria-expanded', 'false');
        });
      });
      carousel.on('resize', () => {
        try { carousel.reInit(); } catch (e) {}
        updateProgress();
      });
      updateProgress();

      if (navPrev) {
        navPrev.addEventListener('click', () => carousel.scrollPrev());
      }
      if (navNext) {
        navNext.addEventListener('click', () => carousel.scrollNext());
      }

      setupDropdownEscape(el);
      el.classList.add('product-upsell--ready');
    });
  }

  function init(el) {
    if (el.__hfUpsellLayoutDone) return;
    el.__hfUpsellLayoutDone = true;

    const layout = el.dataset.layout || 'stacking';
    if (layout === 'carousel') {
      initCarousel(el);
    } else {
      initStacking(el);
    }
  }

  function whenVisible(el, cb) {
    if (!('IntersectionObserver' in window)) { cb(); return; }
    const io = new IntersectionObserver((entries) => {
      if (entries.some((e) => e.isIntersecting)) {
        io.disconnect();
        cb();
      }
    }, { rootMargin: '200px' });
    io.observe(el);
  }

  function bootAll(root) {
    const scope = root && root.querySelectorAll ? root : document;
    scope.querySelectorAll(SELECTOR).forEach((el) => whenVisible(el, () => init(el)));
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => bootAll(), { once: true });
  } else {
    bootAll();
  }

  document.addEventListener('shopify:section:load', (e) => bootAll(e.target));
  document.addEventListener('shopify:block:load', (e) => bootAll(e.target));
})();
